import { getMediaFileEndpoint, getPatientInfoEndpoint, methods, setMediaFileTagsEndpoint } from '../../utils/apiHelper'
import { apiCall } from '../../utils/restclient'
import {
  GET_MEDIA_FILE_SUCCESS,
  GET_PATIENT_DRUG_SCREEN_INFO_SUCCESS,
  LOAD_ACTION,
  SET_FILE_POP_UP_MEDIA_FILE_TAGS_SUCCESS,
  ERROR_ACTION,
} from './FilePopUpConstants'
import { DRUG_SCREEN_STATUS } from '../../utils/constants'

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getMediaFile = (patient, tabId) => {
  const endpoint = getMediaFileEndpoint(patient.PatientId, patient.DrugScreen?.FileId)

  const action = {
    type: LOAD_ACTION,
  }
  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, methods.GET, null, null, {
      success: GET_MEDIA_FILE_SUCCESS,
      error: ERROR_ACTION,
      extraData: {
        tabId,
        patient,
        isFile: patient.DrugScreen.Status === DRUG_SCREEN_STATUS.addressunverified,
      },
    })
  } catch (e) {
    console.log(e)
  }
  return action
}
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const openMediaFile = (patient, tabId, file) => {
  const action = {
    type: GET_MEDIA_FILE_SUCCESS,
    payload: file,
    extraData: { tabId, patient, isFile: true },
  }

  return action
}

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export function setMediaFileTags({ patientId, fileId, updateRequestBody }, tabId) {
  const endpoint = setMediaFileTagsEndpoint(patientId, fileId)
  const action = {
    type: LOAD_ACTION,
  }
  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, methods.PUT, null, JSON.stringify(updateRequestBody), {
      success: SET_FILE_POP_UP_MEDIA_FILE_TAGS_SUCCESS,
      error: ERROR_ACTION,
      extraData: { patientId, mediaFile: { ...updateRequestBody }, tabId },
    })
    return action
  } catch (e) {
    console.log(e)
  }
}
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getPatient = (patientId, tabId) => {
  const endpoint = getPatientInfoEndpoint(patientId)
  const action = {
    type: LOAD_ACTION,
    extraData: { tabId },
  }
  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, 'GET', null, null, {
      success: GET_PATIENT_DRUG_SCREEN_INFO_SUCCESS,
      error: ERROR_ACTION,
      extraData: { patientId, tabId },
    })
    return action
  } catch (e) {
    console.log(e)
  }
}
